import { createSelector } from 'reselect'

const selectLink = (state) => state.launch

const selectLinks = createSelector(
  selectLink,
  (adminLinks) => adminLinks.adminLinks
)

const selectLinksFetching = createSelector(
  selectLink,
  (adminLinks) => adminLinks.isFetching
)
const selectUserLinks = createSelector(
  selectLink,
  (userLinks) => userLinks.userLinks
)

export { selectLinks, selectLinksFetching, selectUserLinks }
